import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section id="final-cta" className="py-24 md:py-36 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-bl from-[#E53935]/5 via-[#C8A24A]/5 to-transparent rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-tr from-[#C8A24A]/5 via-transparent to-transparent rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none"></div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <ScrollReveal>
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#E53935]/5 text-[#E53935] text-xs font-semibold tracking-wider uppercase mb-6 border border-[#E53935]/10">
            {t('trafficMaster.finalTag')}
          </span>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-[#111111] leading-[1.1] mb-5 tracking-tight">
            {t('trafficMaster.finalTitle')}
            <span className="block text-[#E53935] mt-2">
              {t('trafficMaster.finalTitleHighlight')}
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
            {t('trafficMaster.finalSubtitle')}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.link/em25v1"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-4 rounded-full bg-[#E53935] text-white text-base font-semibold hover:bg-[#B71C1C] transition-all duration-300 whitespace-nowrap shadow-[0_4px_24px_rgba(229,57,53,0.35)] hover:shadow-[0_8px_36px_rgba(229,57,53,0.5)] hover:-translate-y-0.5 inline-flex items-center gap-2 cursor-pointer"
            >
              {t('trafficMaster.finalCtaPrimary')}
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://wa.link/em25v1"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-4 rounded-full border-2 border-gray-200 text-[#111111] text-base font-semibold hover:border-[#25D366] hover:text-[#25D366] transition-all duration-300 whitespace-nowrap inline-flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              {t('trafficMaster.finalCtaWhatsApp')}
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}